const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.27,198.85s6.08,50.15,6.08,52.38-5.57,3.34-5.57,6.12a25,25,0,0,1-1.39,6.68s-1.11,1.12-1.11,2,1.95.56,3.62-.27,2.22-3.9,2.22-3.9a49.53,49.53,0,0,0-.83,5.57l-1.11,1.11s-3.34,3.06-1.12,3.34,12.53-3.62,13.09-6.12-1.4-14.48-1.4-14.48,8.08-56.51,8.08-61.8a7.42,7.42,0,0,0-4.46-7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.75,173.22s-3.67,8.66-2,10,2.66,2,2.66,2,1,11.65,2.66,13.65,12.32-1.33,12.32-1.33S165,219.17,165.7,215.17s-2-19-2-20.64-4.66-6-4.66-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.21,174.85l1.87.72,26.68,4.88s4.35,2.29,5.88,4.73.15,11.34.15,11.34L262,217.46,266.47,255l-7.8,5.85.3,3.71c.21.06-.05,4.95-11.62,7,0,0-2.4,1.2-3.1.67-1.77-1.33-.35-1.22-.35-1.22l-4.68,3a16.85,16.85,0,0,1-.74,7c-1.22,4-2.06,4.78-2.06,4.78L238.55,323l5.13,7.31,67,40.67H434.2V98.5H228.7v75.78Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.37,211.7s-11.69,9.47-11.69,12-.84,49.55-.28,50.66S163,260.14,163,260.14l-2.23-20.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.62,192s22.95-21.81,25.73-21.81,48.71,9.18,52.05,9.74,8.91,1.67,8.91,1.67-9.74,12.25-13.08,16.42-5,6.68-5,6.68l-37.58-17.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.83,261.81l33.41-15.59,2.78-9.74L209.43,234s2.23-2.23,1.95,0-3.34,3.06-4.45,5.29-1.12,6.68-2.51,8.63-6.4,4.18-6.4,4.18-37.58,31.45-40.36,33.12-8.35-14.2-8.35-14.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9,375.51H464.2s-10.12-20.23-23.27-26.81-20.23,6.58-36.42-2.53-12.64-30.34-30.85-43-37.43,1.52-54.12.51-21.75-23.27-40-25.8-17.71,18.53-34.4,24.79-28.2-3.93-39.95-3.54-9.61,7.58-20.74,12.64-13.15,2.53-34.39,4.55-26.3,23.77-33.89,29.84-17.7-3.54-33.38,0S44.9,375.51,44.9,375.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9,375.51H464.2s-10.12-20.23-23.27-26.81-20.23,6.58-36.42-2.53-12.64-30.34-30.85-43-37.43,1.52-54.12.51-21.75-23.27-40-25.8-17.71,18.53-34.4,24.79-28.2-3.93-39.95-3.54-9.61,7.58-20.74,12.64-13.15,2.53-34.39,4.55-26.3,23.77-33.89,29.84-17.7-3.54-33.38,0S44.9,375.51,44.9,375.51Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.21,298.57c.79,4.19,10.28,17.84,13.78,25.52-.81-1-1.75-2.18-2.68-3.27-.73-1.27-1.38-2.69-2.11-3.78-1.13-1.69-2.32-3.34-3.61-4.91a40.75,40.75,0,0,0-6.74-6.71,19.14,19.14,0,0,0-10.12-4.21c-1-.07-6.71-.5-5.38,1.8a2.66,2.66,0,0,0,.95.84c3.51,2.15,7.39,3.3,11.09,5,5.54,2.59,12.86,9.49,15.91,12.49l1.55,2.05c-5.45-5.08-14.35-8-17.4-6.57-3.77,1.72,4.34,3.48,11.22,5.26a19.48,19.48,0,0,1,8.34,4.19c1.32,1.78,2.81,3.78,4.3,5.83.18.32.36.62.54.92a21,21,0,0,0-3.56-3.28c-3.52-2.41-13.21-3.87-14.23-.61s5.85,1.77,11.76,2.71a15.86,15.86,0,0,1,8.42,4.47l.39.42c.67,1,1.31,1.87,1.91,2.75,1.41,2.06,2.75,4,4,5.87a33.65,33.65,0,0,0-7-6.83c-5.16-3.54-12.05-4.29-14.56-2.39s9.07,3.62,14.76,5.62a20.57,20.57,0,0,1,8.44,6c1.87,2.65,3.72,5.23,5.71,7.93a78.07,78.07,0,0,0-10.15-7.61c-5.83-3.82-11.87-3.3-13.48-1s3.32,2.45,12.49,4.42a28.27,28.27,0,0,1,13,6.6l2.63,3.5c1,1.37,2.25,2.77,3.52,4.15-1.55-.7-3.84-1.7-6.38-2.79a59.53,59.53,0,0,1-8.21-4.14c-3-1.88-7.08-3.87-10.67-2.27a2,2,0,0,0-1.18,2.78,3.81,3.81,0,0,0,1.77,1.64c4,2.19,8.93,2.77,13.3,3.74a93.41,93.41,0,0,0,12.17,1.89c1.19,1.25,2.43,2.48,3.66,3.64l-1.84.34c-2.17.41-12.75-2.52-18-3.17s-9.5,2.8-3.8,4.8,19.89-.86,19.89-.86l4.1-.77c4.87,4.59,9.38,8.1,9.38,8.1l1.9-1.28s-3.93-1.08-10.53-7.32a17.18,17.18,0,0,1-.06-3.72c.42-7,6.19-14.9,1.76-21.67-1.07-1.64-3.38-2.54-4.66-.74-.92,1.3-.87,3.49-.58,5,1,4.95,2.55,9.34,2.17,14.5,0,.23,0,3.69.24,5.57-.9-.89-1.83-1.86-2.81-2.93a39.09,39.09,0,0,1-1.94-6c-1.27-5.45,0-11.23-.91-16.78-.29-1.7-2.94-5.73-4.24-2.23-.57,1.55.16,4.49.26,6.14.3,4.67.76,9.55,2.6,13.91l-.79-1a86.33,86.33,0,0,1-3.68-13.37c-1.41-7.51-1.17-13.9-3.59-15.9s-2.29,6.36,0,15.15a37.49,37.49,0,0,0,5.05,11.26c-2.58-3.3-5.15-6.69-7.6-10a27.94,27.94,0,0,1-4.15-11.92c-.43-6.67-.83-12.12-3.91-15.43s-3.22-.83-.79,6.7c1.67,5.16,3.67,12.1,6,16.77-1.91-2.59-3.7-5.05-5.31-7.28-1.07-2.31-3.67-8.28-4.48-13.44-1-6.56-2.28-10-4-8.26-1.19,1.22,1,9.18,4.19,15.66-1.35-1.91-2.36-3.38-3-4.25q-.4-.6-.9-1.26a129.61,129.61,0,0,0-5.65-15.54C400.81,300.17,395.36,294,396.21,298.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.21,298.57c.79,4.19,10.28,17.84,13.78,25.52-.81-1-1.75-2.18-2.68-3.27-.73-1.27-1.38-2.69-2.11-3.78-1.13-1.69-2.32-3.34-3.61-4.91a40.75,40.75,0,0,0-6.74-6.71,19.14,19.14,0,0,0-10.12-4.21c-1-.07-6.71-.5-5.38,1.8a2.66,2.66,0,0,0,.95.84c3.51,2.15,7.39,3.3,11.09,5,5.54,2.59,12.86,9.49,15.91,12.49l1.55,2.05c-5.45-5.08-14.35-8-17.4-6.57-3.77,1.72,4.34,3.48,11.22,5.26a19.48,19.48,0,0,1,8.34,4.19c1.32,1.78,2.81,3.78,4.3,5.83.18.32.36.62.54.92a21,21,0,0,0-3.56-3.28c-3.52-2.41-13.21-3.87-14.23-.61s5.85,1.77,11.76,2.71a15.86,15.86,0,0,1,8.42,4.47l.39.42c.67,1,1.31,1.87,1.91,2.75,1.41,2.06,2.75,4,4,5.87a33.65,33.65,0,0,0-7-6.83c-5.16-3.54-12.05-4.29-14.56-2.39s9.07,3.62,14.76,5.62a20.57,20.57,0,0,1,8.44,6c1.87,2.65,3.72,5.23,5.71,7.93a78.07,78.07,0,0,0-10.15-7.61c-5.83-3.82-11.87-3.3-13.48-1s3.32,2.45,12.49,4.42a28.27,28.27,0,0,1,13,6.6l2.63,3.5c1,1.37,2.25,2.77,3.52,4.15-1.55-.7-3.84-1.7-6.38-2.79a59.53,59.53,0,0,1-8.21-4.14c-3-1.88-7.08-3.87-10.67-2.27a2,2,0,0,0-1.18,2.78,3.81,3.81,0,0,0,1.77,1.64c4,2.19,8.93,2.77,13.3,3.74a93.41,93.41,0,0,0,12.17,1.89c1.19,1.25,2.43,2.48,3.66,3.64l-1.84.34c-2.17.41-12.75-2.52-18-3.17s-9.5,2.8-3.8,4.8,19.89-.86,19.89-.86l4.1-.77c4.87,4.59,9.38,8.1,9.38,8.1l1.9-1.28s-3.93-1.08-10.53-7.32a17.18,17.18,0,0,1-.06-3.72c.42-7,6.19-14.9,1.76-21.67-1.07-1.64-3.38-2.54-4.66-.74-.92,1.3-.87,3.49-.58,5,1,4.95,2.55,9.34,2.17,14.5,0,.23,0,3.69.24,5.57-.9-.89-1.83-1.86-2.81-2.93a39.09,39.09,0,0,1-1.94-6c-1.27-5.45,0-11.23-.91-16.78-.29-1.7-2.94-5.73-4.24-2.23-.57,1.55.16,4.49.26,6.14.3,4.67.76,9.55,2.6,13.91l-.79-1a86.33,86.33,0,0,1-3.68-13.37c-1.41-7.51-1.17-13.9-3.59-15.9s-2.29,6.36,0,15.15a37.49,37.49,0,0,0,5.05,11.26c-2.58-3.3-5.15-6.69-7.6-10a27.94,27.94,0,0,1-4.15-11.92c-.43-6.67-.83-12.12-3.91-15.43s-3.22-.83-.79,6.7c1.67,5.16,3.67,12.1,6,16.77-1.91-2.59-3.7-5.05-5.31-7.28-1.07-2.31-3.67-8.28-4.48-13.44-1-6.56-2.28-10-4-8.26-1.19,1.22,1,9.18,4.19,15.66-1.35-1.91-2.36-3.38-3-4.25q-.4-.6-.9-1.26a129.61,129.61,0,0,0-5.65-15.54C400.81,300.17,395.36,294,396.21,298.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.09,279.08c-2.32,3.57-4.86,20-7.62,28,.14-1.32.24-2.78.31-4.21.35-1.42.86-2.89,1.09-4.2.34-2,.61-4,.77-6a40.35,40.35,0,0,0-.26-9.51,19.19,19.19,0,0,0-4.43-10c-.63-.71-4.51-5-5.13-2.41a2.58,2.58,0,0,0,.11,1.26c1.05,4,3.07,7.49,4.56,11.3,2.22,5.7,2.76,15.74,2.9,20-.08.69-.18,1.56-.29,2.55-.44-7.43-4.9-15.67-8.07-16.76-3.92-1.34.74,5.52,4.5,11.55a19.55,19.55,0,0,1,3.15,8.78c-.27,2.21-.58,4.68-.91,7.19-.09.36-.17.7-.24,1.05a21.31,21.31,0,0,0-.32-4.84c-.89-4.17-6.9-11.91-9.89-10.25s3,5.32,6.65,10.07a15.8,15.8,0,0,1,3,9.05c0,.19,0,.38,0,.57-.17,1.15-.34,2.26-.51,3.31-.4,2.46-.76,4.78-1.11,7a34,34,0,0,0-.34-9.76c-1.31-6.12-5.78-11.42-8.91-11.77s4.07,8.87,6.82,14.25a20.43,20.43,0,0,1,2,10.14c-.47,3.2-.91,6.35-1.33,9.68a79.48,79.48,0,0,0-2.1-12.52c-1.59-6.78-6.33-10.58-9.11-10s.72,4.06,6,11.81a28.27,28.27,0,0,1,4.84,13.72c-.17,1.4-.34,2.84-.51,4.34-.19,1.71-.29,3.56-.31,5.44-.65-1.58-1.61-3.89-2.7-6.42a59.94,59.94,0,0,1-3.09-8.66c-.9-3.45-2.46-7.69-6.16-9a2,2,0,0,0-2.77,1.2,3.84,3.84,0,0,0,.14,2.41c1.36,4.32,4.56,8.16,7.05,11.88a94.83,94.83,0,0,0,7.52,9.76c0,1.73.05,3.47.14,5.16l-1.57-1c-1.86-1.2-7.49-10.62-10.84-14.7s-8.81-4.53-6.07.85,15,13.09,15,13.09l3.5,2.28c.37,6.68,1.21,12.33,1.21,12.33l2.26.38s-2.1-3.49-2.58-12.55a16.82,16.82,0,0,1,2.53-2.74c5.12-4.78,14.75-6.52,16.21-14.49.35-1.92-.69-4.16-2.87-3.74-1.56.3-3,1.93-3.84,3.2-2.71,4.25-4.6,8.52-8.42,12-.17.16-2.54,2.68-3.67,4.2,0-1.26-.05-2.61,0-4.06a39.82,39.82,0,0,1,2.74-5.7c2.84-4.82,7.75-8.12,10.91-12.78,1-1.43,1.82-6.17-1.53-4.53-1.49.73-3,3.36-4,4.62-3,3.59-6,7.45-7.72,11.87,0-.42.08-.84.11-1.26a87,87,0,0,1,6.56-12.22c4.16-6.41,8.73-10.88,8.36-14s-6,3-10.47,11a37.53,37.53,0,0,0-4.1,11.64c.41-4.18.88-8.4,1.36-12.46a27.71,27.71,0,0,1,5.22-11.49c4.28-5.13,7.75-9.35,7.8-13.87s-1.76-2.83-5.19,4.3c-2.35,4.89-5.68,11.3-7.24,16.27.41-3.19.81-6.21,1.19-8.93.81-2.41,3-8.53,6-12.82,3.78-5.46,5.24-8.83,2.79-8.74-1.7.06-5.64,7.3-7.76,14.22.34-2.31.62-4.07.8-5.11q.12-.7.21-1.53A131.23,131.23,0,0,0,466,292.53C469.32,283.4,469.61,275.2,467.09,279.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.09,279.08c-2.32,3.57-4.86,20-7.62,28,.14-1.32.24-2.78.31-4.21.35-1.42.86-2.89,1.09-4.2.34-2,.61-4,.77-6a40.35,40.35,0,0,0-.26-9.51,19.19,19.19,0,0,0-4.43-10c-.63-.71-4.51-5-5.13-2.41a2.58,2.58,0,0,0,.11,1.26c1.05,4,3.07,7.49,4.56,11.3,2.22,5.7,2.76,15.74,2.9,20-.08.69-.18,1.56-.29,2.55-.44-7.43-4.9-15.67-8.07-16.76-3.92-1.34.74,5.52,4.5,11.55a19.55,19.55,0,0,1,3.15,8.78c-.27,2.21-.58,4.68-.91,7.19-.09.36-.17.7-.24,1.05a21.31,21.31,0,0,0-.32-4.84c-.89-4.17-6.9-11.91-9.89-10.25s3,5.32,6.65,10.07a15.8,15.8,0,0,1,3,9.05c0,.19,0,.38,0,.57-.17,1.15-.34,2.26-.51,3.31-.4,2.46-.76,4.78-1.11,7a34,34,0,0,0-.34-9.76c-1.31-6.12-5.78-11.42-8.91-11.77s4.07,8.87,6.82,14.25a20.43,20.43,0,0,1,2,10.14c-.47,3.2-.91,6.35-1.33,9.68a79.48,79.48,0,0,0-2.1-12.52c-1.59-6.78-6.33-10.58-9.11-10s.72,4.06,6,11.81a28.27,28.27,0,0,1,4.84,13.72c-.17,1.4-.34,2.84-.51,4.34-.19,1.71-.29,3.56-.31,5.44-.65-1.58-1.61-3.89-2.7-6.42a59.94,59.94,0,0,1-3.09-8.66c-.9-3.45-2.46-7.69-6.16-9a2,2,0,0,0-2.77,1.2,3.84,3.84,0,0,0,.14,2.41c1.36,4.32,4.56,8.16,7.05,11.88a94.83,94.83,0,0,0,7.52,9.76c0,1.73.05,3.47.14,5.16l-1.57-1c-1.86-1.2-7.49-10.62-10.84-14.7s-8.81-4.53-6.07.85,15,13.09,15,13.09l3.5,2.28c.37,6.68,1.21,12.33,1.21,12.33l2.26.38s-2.1-3.49-2.58-12.55a16.82,16.82,0,0,1,2.53-2.74c5.12-4.78,14.75-6.52,16.21-14.49.35-1.92-.69-4.16-2.87-3.74-1.56.3-3,1.93-3.84,3.2-2.71,4.25-4.6,8.52-8.42,12-.17.16-2.54,2.68-3.67,4.2,0-1.26-.05-2.61,0-4.06a39.82,39.82,0,0,1,2.74-5.7c2.84-4.82,7.75-8.12,10.91-12.78,1-1.43,1.82-6.17-1.53-4.53-1.49.73-3,3.36-4,4.62-3,3.59-6,7.45-7.72,11.87,0-.42.08-.84.11-1.26a87,87,0,0,1,6.56-12.22c4.16-6.41,8.73-10.88,8.36-14s-6,3-10.47,11a37.53,37.53,0,0,0-4.1,11.64c.41-4.18.88-8.4,1.36-12.46a27.71,27.71,0,0,1,5.22-11.49c4.28-5.13,7.75-9.35,7.8-13.87s-1.76-2.83-5.19,4.3c-2.35,4.89-5.68,11.3-7.24,16.27.41-3.19.81-6.21,1.19-8.93.81-2.41,3-8.53,6-12.82,3.78-5.46,5.24-8.83,2.79-8.74-1.7.06-5.64,7.3-7.76,14.22.34-2.31.62-4.07.8-5.11q.12-.7.21-1.53A131.23,131.23,0,0,0,466,292.53C469.32,283.4,469.61,275.2,467.09,279.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,315c.47,3.14,7.16,13.61,9.54,19.43-.57-.81-1.23-1.67-1.9-2.51-.51-1-.95-2.05-1.47-2.89-.79-1.29-1.63-2.55-2.54-3.76a30.28,30.28,0,0,0-4.85-5.2,14.27,14.27,0,0,0-7.42-3.43c-.71-.08-5-.57-4.07,1.18a1.8,1.8,0,0,0,.69.65c2.56,1.71,5.41,2.68,8.13,4.09C40.75,324.6,46,330,48.2,332.29l1.09,1.57c-3.91-3.95-10.47-6.36-12.79-5.41-2.86,1.18,3.14,2.73,8.22,4.26a14.39,14.39,0,0,1,6.1,3.36c.94,1.36,2,2.91,3,4.48.12.24.25.47.38.7a15.42,15.42,0,0,0-2.56-2.55c-2.56-1.9-9.75-3.27-10.61-.87s4.32,1.49,8.7,2.36a11.88,11.88,0,0,1,6.16,3.58c.09.12.18.22.28.33.47.72.92,1.43,1.34,2.1,1,1.58,1.93,3.06,2.86,4.49a25.87,25.87,0,0,0-5-5.29c-3.75-2.79-8.88-3.55-10.8-2.2s6.66,3,10.85,4.62a15.35,15.35,0,0,1,6.13,4.69c1.31,2,2.62,4,4,6.08a58.3,58.3,0,0,0-7.36-6c-4.24-3-8.76-2.81-10-1.11s2.41,1.93,9.19,3.66a21.1,21.1,0,0,1,9.49,5.3c.59.87,1.21,1.76,1.86,2.69a40.41,40.41,0,0,0,2.5,3.19c-1.14-.56-2.81-1.38-4.68-2.26a45,45,0,0,1-6-3.33c-2.21-1.49-5.17-3.09-7.9-2a1.47,1.47,0,0,0-1,2A2.91,2.91,0,0,0,53,362.08c2.9,1.75,6.58,2.32,9.82,3.17a69.88,69.88,0,0,0,9,1.76c.86,1,1.75,1.92,2.63,2.82l-1.38.21c-1.64.24-9.44-2.25-13.33-2.9s-7.17,1.82-3,3.48,14.86-.07,14.86-.07l3.09-.45c3.5,3.56,6.76,6.31,6.76,6.31l1.45-.9s-2.89-.92-7.64-5.76a12.82,12.82,0,0,1,.07-2.78c.51-5.21,5-10.94,1.93-16.12-.75-1.25-2.44-2-3.46-.68a5.29,5.29,0,0,0-.57,3.69c.58,3.72,1.63,7,1.21,10.87,0,.18-.1,2.76,0,4.16-.64-.68-1.31-1.43-2-2.26a30.16,30.16,0,0,1-1.28-4.55c-.78-4.1.34-8.38-.19-12.54-.17-1.28-2-4.36-3.1-1.79-.47,1.14,0,3.36,0,4.59a31.86,31.86,0,0,0,1.54,10.45c-.19-.25-.38-.5-.56-.76A64.67,64.67,0,0,1,66.53,352c-.83-5.64-.47-10.4-2.22-12s-1.89,4.69-.46,11.3a28.28,28.28,0,0,0,3.45,8.56c-1.83-2.55-3.65-5.14-5.38-7.66a20.71,20.71,0,0,1-2.75-9c-.13-5-.28-9.06-2.48-11.62s-2.38-.72-.78,5c1.1,3.9,2.39,9.13,4,12.69-1.34-2-2.61-3.88-3.74-5.59a42,42,0,0,1-3-10.16c-.57-4.92-1.41-7.53-2.75-6.27-.92.87.45,6.87,2.68,11.8-1-1.47-1.67-2.59-2.08-3.26q-.28-.45-.63-1A99.08,99.08,0,0,0,46.63,323C44,316.27,40.08,311.53,40.58,315Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,315c.47,3.14,7.16,13.61,9.54,19.43-.57-.81-1.23-1.67-1.9-2.51-.51-1-.95-2.05-1.47-2.89-.79-1.29-1.63-2.55-2.54-3.76a30.28,30.28,0,0,0-4.85-5.2,14.27,14.27,0,0,0-7.42-3.43c-.71-.08-5-.57-4.07,1.18a1.8,1.8,0,0,0,.69.65c2.56,1.71,5.41,2.68,8.13,4.09C40.75,324.6,46,330,48.2,332.29l1.09,1.57c-3.91-3.95-10.47-6.36-12.79-5.41-2.86,1.18,3.14,2.73,8.22,4.26a14.39,14.39,0,0,1,6.1,3.36c.94,1.36,2,2.91,3,4.48.12.24.25.47.38.7a15.42,15.42,0,0,0-2.56-2.55c-2.56-1.9-9.75-3.27-10.61-.87s4.32,1.49,8.7,2.36a11.88,11.88,0,0,1,6.16,3.58c.09.12.18.22.28.33.47.72.92,1.43,1.34,2.1,1,1.58,1.93,3.06,2.86,4.49a25.87,25.87,0,0,0-5-5.29c-3.75-2.79-8.88-3.55-10.8-2.2s6.66,3,10.85,4.62a15.35,15.35,0,0,1,6.13,4.69c1.31,2,2.62,4,4,6.08a58.3,58.3,0,0,0-7.36-6c-4.24-3-8.76-2.81-10-1.11s2.41,1.93,9.19,3.66a21.1,21.1,0,0,1,9.49,5.3c.59.87,1.21,1.76,1.86,2.69a40.41,40.41,0,0,0,2.5,3.19c-1.14-.56-2.81-1.38-4.68-2.26a45,45,0,0,1-6-3.33c-2.21-1.49-5.17-3.09-7.9-2a1.47,1.47,0,0,0-1,2A2.91,2.91,0,0,0,53,362.08c2.9,1.75,6.58,2.32,9.82,3.17a69.88,69.88,0,0,0,9,1.76c.86,1,1.75,1.92,2.63,2.82l-1.38.21c-1.64.24-9.44-2.25-13.33-2.9s-7.17,1.82-3,3.48,14.86-.07,14.86-.07l3.09-.45c3.5,3.56,6.76,6.31,6.76,6.31l1.45-.9s-2.89-.92-7.64-5.76a12.82,12.82,0,0,1,.07-2.78c.51-5.21,5-10.94,1.93-16.12-.75-1.25-2.44-2-3.46-.68a5.29,5.29,0,0,0-.57,3.69c.58,3.72,1.63,7,1.21,10.87,0,.18-.1,2.76,0,4.16-.64-.68-1.31-1.43-2-2.26a30.16,30.16,0,0,1-1.28-4.55c-.78-4.1.34-8.38-.19-12.54-.17-1.28-2-4.36-3.1-1.79-.47,1.14,0,3.36,0,4.59a31.86,31.86,0,0,0,1.54,10.45c-.19-.25-.38-.5-.56-.76A64.67,64.67,0,0,1,66.53,352c-.83-5.64-.47-10.4-2.22-12s-1.89,4.69-.46,11.3a28.28,28.28,0,0,0,3.45,8.56c-1.83-2.55-3.65-5.14-5.38-7.66a20.71,20.71,0,0,1-2.75-9c-.13-5-.28-9.06-2.48-11.62s-2.38-.72-.78,5c1.1,3.9,2.39,9.13,4,12.69-1.34-2-2.61-3.88-3.74-5.59a42,42,0,0,1-3-10.16c-.57-4.92-1.41-7.53-2.75-6.27-.92.87.45,6.87,2.68,11.8-1-1.47-1.67-2.59-2.08-3.26q-.28-.45-.63-1A99.08,99.08,0,0,0,46.63,323C44,316.27,40.08,311.53,40.58,315Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,312.52c-2.67,1.72-9.44,12.13-13.76,16.71.5-.86,1-1.82,1.5-2.77.67-.87,1.47-1.71,2-2.53.85-1.26,1.65-2.55,2.38-3.88a30.33,30.33,0,0,0,2.73-6.55,14.16,14.16,0,0,0,.06-8.18c-.21-.68-1.54-4.79-2.75-3.21a1.83,1.83,0,0,0-.31.89c-.51,3-.21,6-.37,9.09-.23,4.56-2.94,11.56-4.16,14.52-.26.44-.59,1-1,1.64,2-5.19,1.47-12.16-.35-13.88-2.26-2.12-1.19,4-.48,9.24a14.6,14.6,0,0,1-.55,6.95c-.86,1.41-1.83,3-2.82,4.61l-.49.64A15.4,15.4,0,0,0,96,332.42c.67-3.11-1-10.22-3.59-10s.43,4.54,1.44,8.89a11.76,11.76,0,0,1-.72,7.09l-.18.39c-.47.73-.92,1.43-1.36,2.09-1,1.56-2,3-2.92,4.45a25.38,25.38,0,0,0,2.76-6.74c1-4.57-.43-9.55-2.45-10.75s0,7.29.27,11.79a15.31,15.31,0,0,1-1.75,7.52c-1.3,2-2.56,4-3.87,6.18A58.79,58.79,0,0,0,86,344.15c1-5.1-1.06-9.14-3.14-9.59s-.76,3,.46,9.88a21.09,21.09,0,0,1-.91,10.83c-.55.9-1.1,1.83-1.68,2.8s-1.28,2.33-1.88,3.61c0-1.28.1-3.14.13-5.2a46.08,46.08,0,0,1,.55-6.85c.45-2.62.69-6-1.43-8a1.46,1.46,0,0,0-2.25,0,2.81,2.81,0,0,0-.64,1.68c-.4,3.37.6,7,1.15,10.26a71.4,71.4,0,0,0,2.13,9c-.53,1.17-1,2.38-1.49,3.55l-.76-1.17c-.89-1.39-1.84-9.53-2.86-13.34s-4.62-5.78-4.4-1.28,6.2,13.52,6.2,13.52l1.69,2.62c-1.8,4.65-3,8.76-3,8.76l1.41.95s-.35-3,2.1-9.33A12.23,12.23,0,0,1,80,365.66c5-1.68,12,.08,15.48-4.89.83-1.2.81-3-.8-3.43a5.25,5.25,0,0,0-3.6,1c-3.15,2.06-5.74,4.39-9.41,5.58-.17.06-2.55,1.05-3.79,1.73.36-.86.77-1.79,1.24-2.76a28.21,28.21,0,0,1,3.61-3c3.41-2.41,7.77-3.15,11.35-5.36,1.09-.67,3.13-3.64.35-3.55-1.24,0-3.07,1.37-4.17,1.91a31.87,31.87,0,0,0-8.89,5.71c.15-.27.3-.55.46-.82A64.82,64.82,0,0,1,90,351.42c4.8-3.08,9.28-4.72,10-7s-5,.21-10.48,4.25a28,28,0,0,0-6.37,6.67c1.56-2.72,3.18-5.45,4.75-8.06A20.72,20.72,0,0,1,95,341.09c4.5-2.18,8.15-4,9.57-7s-.33-2.46-4.85,1.34c-3.1,2.61-7.33,5.94-9.92,8.85,1.26-2,2.46-4,3.55-5.71a41.83,41.83,0,0,1,8-6.89c4.25-2.55,6.28-4.4,4.58-5.09-1.18-.48-6.08,3.24-9.65,7.3l2.11-3.23c.2-.3.41-.63.62-1a98.51,98.51,0,0,0,9.15-8.29C113.21,316.14,115.92,310.65,113,312.52Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,312.52c-2.67,1.72-9.44,12.13-13.76,16.71.5-.86,1-1.82,1.5-2.77.67-.87,1.47-1.71,2-2.53.85-1.26,1.65-2.55,2.38-3.88a30.33,30.33,0,0,0,2.73-6.55,14.16,14.16,0,0,0,.06-8.18c-.21-.68-1.54-4.79-2.75-3.21a1.83,1.83,0,0,0-.31.89c-.51,3-.21,6-.37,9.09-.23,4.56-2.94,11.56-4.16,14.52-.26.44-.59,1-1,1.64,2-5.19,1.47-12.16-.35-13.88-2.26-2.12-1.19,4-.48,9.24a14.6,14.6,0,0,1-.55,6.95c-.86,1.41-1.83,3-2.82,4.61l-.49.64A15.4,15.4,0,0,0,96,332.42c.67-3.11-1-10.22-3.59-10s.43,4.54,1.44,8.89a11.76,11.76,0,0,1-.72,7.09l-.18.39c-.47.73-.92,1.43-1.36,2.09-1,1.56-2,3-2.92,4.45a25.38,25.38,0,0,0,2.76-6.74c1-4.57-.43-9.55-2.45-10.75s0,7.29.27,11.79a15.31,15.31,0,0,1-1.75,7.52c-1.3,2-2.56,4-3.87,6.18A58.79,58.79,0,0,0,86,344.15c1-5.1-1.06-9.14-3.14-9.59s-.76,3,.46,9.88a21.09,21.09,0,0,1-.91,10.83c-.55.9-1.1,1.83-1.68,2.8s-1.28,2.33-1.88,3.61c0-1.28.1-3.14.13-5.2a46.08,46.08,0,0,1,.55-6.85c.45-2.62.69-6-1.43-8a1.46,1.46,0,0,0-2.25,0,2.81,2.81,0,0,0-.64,1.68c-.4,3.37.6,7,1.15,10.26a71.4,71.4,0,0,0,2.13,9c-.53,1.17-1,2.38-1.49,3.55l-.76-1.17c-.89-1.39-1.84-9.53-2.86-13.34s-4.62-5.78-4.4-1.28,6.2,13.52,6.2,13.52l1.69,2.62c-1.8,4.65-3,8.76-3,8.76l1.41.95s-.35-3,2.1-9.33A12.23,12.23,0,0,1,80,365.66c5-1.68,12,.08,15.48-4.89.83-1.2.81-3-.8-3.43a5.25,5.25,0,0,0-3.6,1c-3.15,2.06-5.74,4.39-9.41,5.58-.17.06-2.55,1.05-3.79,1.73.36-.86.77-1.79,1.24-2.76a28.21,28.21,0,0,1,3.61-3c3.41-2.41,7.77-3.15,11.35-5.36,1.09-.67,3.13-3.64.35-3.55-1.24,0-3.07,1.37-4.17,1.91a31.87,31.87,0,0,0-8.89,5.71c.15-.27.3-.55.46-.82A64.82,64.82,0,0,1,90,351.42c4.8-3.08,9.28-4.72,10-7s-5,.21-10.48,4.25a28,28,0,0,0-6.37,6.67c1.56-2.72,3.18-5.45,4.75-8.06A20.72,20.72,0,0,1,95,341.09c4.5-2.18,8.15-4,9.57-7s-.33-2.46-4.85,1.34c-3.1,2.61-7.33,5.94-9.92,8.85,1.26-2,2.46-4,3.55-5.71a41.83,41.83,0,0,1,8-6.89c4.25-2.55,6.28-4.4,4.58-5.09-1.18-.48-6.08,3.24-9.65,7.3l2.11-3.23c.2-.3.41-.63.62-1a98.51,98.51,0,0,0,9.15-8.29C113.21,316.14,115.92,310.65,113,312.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,312.79c-2.68,1.73-9.45,12.14-13.77,16.71.5-.85,1-1.81,1.5-2.77.67-.86,1.47-1.71,2-2.52.85-1.26,1.65-2.55,2.38-3.88a30.54,30.54,0,0,0,2.73-6.55,14.24,14.24,0,0,0,.07-8.18c-.22-.68-1.55-4.79-2.76-3.22a1.9,1.9,0,0,0-.31.9c-.5,3-.21,6-.37,9.08-.23,4.57-2.94,11.57-4.16,14.53-.26.44-.59,1-1,1.64,2-5.2,1.48-12.17-.35-13.88-2.26-2.12-1.19,4-.48,9.24a14.41,14.41,0,0,1-.55,6.94c-.86,1.42-1.83,3-2.82,4.62-.17.21-.33.43-.49.64a15.4,15.4,0,0,0,1.27-3.39c.68-3.11-1-10.22-3.59-10s.43,4.54,1.44,8.89a11.71,11.71,0,0,1-.72,7.08l-.18.4c-.47.72-.92,1.43-1.36,2.09-1,1.55-2,3-2.92,4.45a25.31,25.31,0,0,0,2.76-6.75c1-4.56-.43-9.54-2.45-10.74s.05,7.29.27,11.79a15.31,15.31,0,0,1-1.75,7.52c-1.3,2-2.56,4-3.87,6.18a59.09,59.09,0,0,0,2.41-9.17c1-5.1-1.06-9.14-3.14-9.59s-.76,3,.47,9.88a21.2,21.2,0,0,1-.92,10.83c-.55.9-1.1,1.83-1.68,2.8s-1.28,2.33-1.88,3.6c0-1.27.1-3.13.13-5.2a46.05,46.05,0,0,1,.55-6.84c.45-2.62.69-6-1.43-8a1.46,1.46,0,0,0-2.25,0,2.81,2.81,0,0,0-.64,1.68c-.4,3.36.6,7,1.15,10.26a70.67,70.67,0,0,0,2.13,8.94c-.53,1.18-1,2.38-1.49,3.56l-.76-1.18c-.89-1.39-1.84-9.52-2.86-13.33s-4.62-5.78-4.4-1.28,6.2,13.51,6.2,13.51l1.69,2.62c-1.8,4.66-3,8.77-3,8.77l1.41.95s-.35-3,2.1-9.33a12.6,12.6,0,0,1,2.56-1.1c5-1.68,12,.09,15.48-4.88.83-1.21.81-3.05-.8-3.43a5.2,5.2,0,0,0-3.6,1c-3.15,2.06-5.74,4.39-9.41,5.58-.17.05-2.55,1.05-3.79,1.73.36-.87.77-1.79,1.24-2.77a29,29,0,0,1,3.61-3c3.42-2.41,7.77-3.15,11.35-5.36,1.1-.67,3.13-3.64.35-3.56-1.24,0-3.07,1.38-4.17,1.91a32.13,32.13,0,0,0-8.89,5.72l.46-.83a65.14,65.14,0,0,1,8.21-6.31c4.8-3.09,9.28-4.72,10-7s-5,.21-10.48,4.25a28,28,0,0,0-6.37,6.67c1.56-2.72,3.18-5.45,4.75-8.07a20.82,20.82,0,0,1,7.07-6.22c4.5-2.18,8.15-4,9.57-7.05s-.33-2.47-4.85,1.34c-3.1,2.6-7.33,5.94-9.92,8.85,1.26-2.05,2.46-4,3.55-5.72a42.2,42.2,0,0,1,8-6.88c4.25-2.56,6.28-4.4,4.58-5.09-1.18-.48-6.08,3.24-9.65,7.3,1-1.47,1.68-2.58,2.11-3.23.2-.3.41-.63.62-1a99.06,99.06,0,0,0,9.16-8.28C142.51,316.42,145.22,310.93,142.32,312.79Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,312.79c-2.68,1.73-9.45,12.14-13.77,16.71.5-.85,1-1.81,1.5-2.77.67-.86,1.47-1.71,2-2.52.85-1.26,1.65-2.55,2.38-3.88a30.54,30.54,0,0,0,2.73-6.55,14.24,14.24,0,0,0,.07-8.18c-.22-.68-1.55-4.79-2.76-3.22a1.9,1.9,0,0,0-.31.9c-.5,3-.21,6-.37,9.08-.23,4.57-2.94,11.57-4.16,14.53-.26.44-.59,1-1,1.64,2-5.2,1.48-12.17-.35-13.88-2.26-2.12-1.19,4-.48,9.24a14.41,14.41,0,0,1-.55,6.94c-.86,1.42-1.83,3-2.82,4.62-.17.21-.33.43-.49.64a15.4,15.4,0,0,0,1.27-3.39c.68-3.11-1-10.22-3.59-10s.43,4.54,1.44,8.89a11.71,11.71,0,0,1-.72,7.08l-.18.4c-.47.72-.92,1.43-1.36,2.09-1,1.55-2,3-2.92,4.45a25.31,25.31,0,0,0,2.76-6.75c1-4.56-.43-9.54-2.45-10.74s.05,7.29.27,11.79a15.31,15.31,0,0,1-1.75,7.52c-1.3,2-2.56,4-3.87,6.18a59.09,59.09,0,0,0,2.41-9.17c1-5.1-1.06-9.14-3.14-9.59s-.76,3,.47,9.88a21.2,21.2,0,0,1-.92,10.83c-.55.9-1.1,1.83-1.68,2.8s-1.28,2.33-1.88,3.6c0-1.27.1-3.13.13-5.2a46.05,46.05,0,0,1,.55-6.84c.45-2.62.69-6-1.43-8a1.46,1.46,0,0,0-2.25,0,2.81,2.81,0,0,0-.64,1.68c-.4,3.36.6,7,1.15,10.26a70.67,70.67,0,0,0,2.13,8.94c-.53,1.18-1,2.38-1.49,3.56l-.76-1.18c-.89-1.39-1.84-9.52-2.86-13.33s-4.62-5.78-4.4-1.28,6.2,13.51,6.2,13.51l1.69,2.62c-1.8,4.66-3,8.77-3,8.77l1.41.95s-.35-3,2.1-9.33a12.6,12.6,0,0,1,2.56-1.1c5-1.68,12,.09,15.48-4.88.83-1.21.81-3.05-.8-3.43a5.2,5.2,0,0,0-3.6,1c-3.15,2.06-5.74,4.39-9.41,5.58-.17.05-2.55,1.05-3.79,1.73.36-.87.77-1.79,1.24-2.77a29,29,0,0,1,3.61-3c3.42-2.41,7.77-3.15,11.35-5.36,1.1-.67,3.13-3.64.35-3.56-1.24,0-3.07,1.38-4.17,1.91a32.13,32.13,0,0,0-8.89,5.72l.46-.83a65.14,65.14,0,0,1,8.21-6.31c4.8-3.09,9.28-4.72,10-7s-5,.21-10.48,4.25a28,28,0,0,0-6.37,6.67c1.56-2.72,3.18-5.45,4.75-8.07a20.82,20.82,0,0,1,7.07-6.22c4.5-2.18,8.15-4,9.57-7.05s-.33-2.47-4.85,1.34c-3.1,2.6-7.33,5.94-9.92,8.85,1.26-2.05,2.46-4,3.55-5.72a42.2,42.2,0,0,1,8-6.88c4.25-2.56,6.28-4.4,4.58-5.09-1.18-.48-6.08,3.24-9.65,7.3,1-1.47,1.68-2.58,2.11-3.23.2-.3.41-.63.62-1a99.06,99.06,0,0,0,9.16-8.28C142.51,316.42,145.22,310.93,142.32,312.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.45,123.39s-3.83-11-14.85-11.49-9.1,10.06-16.76,12.93-10.54-5.27-17.25-3.35-2.39,7.18-8.14,9.1-5.27-3.35-13.89,1-10.54,5.75-12.46,6.23-19.16,3.35-19.16,3.35H470.22s3.36-10.54-3.35-14.85S460.64,127.23,453.45,123.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.45,123.39s-3.83-11-14.85-11.49-9.1,10.06-16.76,12.93-10.54-5.27-17.25-3.35-2.39,7.18-8.14,9.1-5.27-3.35-13.89,1-10.54,5.75-12.46,6.23-19.16,3.35-19.16,3.35H470.22s3.36-10.54-3.35-14.85S460.64,127.23,453.45,123.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,105.59s-2.33-6.68-9-7-5.51,6.09-10.16,7.84-6.39-3.2-10.46-2-1.45,4.36-4.93,5.52-3.2-2-8.43.58-6.38,3.49-7.55,3.78-11.61,2-11.61,2h72.31s2-6.39-2-9S238.62,107.91,234.27,105.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,105.59s-2.33-6.68-9-7-5.51,6.09-10.16,7.84-6.39-3.2-10.46-2-1.45,4.36-4.93,5.52-3.2-2-8.43.58-6.38,3.49-7.55,3.78-11.61,2-11.61,2h72.31s2-6.39-2-9S238.62,107.91,234.27,105.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,223s-3.13-9-12.12-9.38-7.44,8.21-13.69,10.56-8.61-4.31-14.08-2.74-2,5.86-6.65,7.43-4.3-2.74-11.34.78-8.6,4.69-10.17,5.09-15.64,2.73-15.64,2.73h97.38s2.73-8.6-2.74-12.12S118.49,226.15,112.63,223Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.63,223s-3.13-9-12.12-9.38-7.44,8.21-13.69,10.56-8.61-4.31-14.08-2.74-2,5.86-6.65,7.43-4.3-2.74-11.34.78-8.6,4.69-10.17,5.09-15.64,2.73-15.64,2.73h97.38s2.73-8.6-2.74-12.12S118.49,226.15,112.63,223Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.3,
    cy: 393.98,
    rx: 106.06,
    ry: 7.52,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.68,
    cy: 385.22,
    rx: 60.13,
    ry: 3.76,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.3,
    cy: 393.98,
    rx: 106.06,
    ry: 7.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.68,
    cy: 385.22,
    rx: 60.13,
    ry: 3.76,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-32"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 227.53,
    y1: 281.85,
    x2: 246.18,
    y2: 268.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.48,374.66l-1.05,11.85s-5.31,2.33-5.3,3.11,1,1.85,5.33,1.85,5.74-1.64,5.74-2.87,9.22-11.48,9.22-11.48a3.79,3.79,0,0,0-.61-3.69c-1.44-1.64-6.36-1.84-6.36-1.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,390.41s7.21-.47,9.14-1.57,8.8-11.56,9.35-12.39a4.71,4.71,0,0,0,.55-2.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,371.76s5.85,1.11,5.29,3.62-9.74,13.64-11.13,15-10,1.39-9.74,0,5.29-3.9,5.29-3.9l1.67-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,384.29,155.3,392.7s-2.25,1.64,2.26,1.64,28.28.2,28.28.2,2.67.62,3.28-.61c1-2,1.44-3.28.82-3.9S172.52,384.29,172.52,384.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92,392.41h30.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36,385.36s-17.54,7.52-17.26,8.35,17.81.84,24.49.84,11.42.28,11.42-1.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,371.76l-57.89-42.31-2-42.59a27.93,27.93,0,0,1-7.14,4.57c-3.58,1.37-24.32,11.85-24.32,11.85s9.19,32.57,10.86,35.36,71.82,37.85,71.82,37.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,391.49s-2.23-.56-4.73-1.12-13.92-5-13.92-5a9.77,9.77,0,0,1-.28-2.78,4,4,0,0,1,1.67-3.06s-43.43-57.9-44.54-59.57-.28-4.46,7.24-10.3,56.72-35.87,56.72-35.87c-1.89-2.24,1.67-3.62,1.67-3.62l4.46,1.39,29.23,10.3,11.69-7.79s1.95,7.23-5.29,12.8-73.43,35-73.43,35l-1.1.07L189.17,387S191.17,390.56,190,391.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "153.07 314.54 158.57 321.42 156.37 312.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.28,303.81s11.28,17.61,15.41,21.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,303.26a82.58,82.58,0,0,0,9.9,7.43",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.71 210.03 189.65 236.65 198.19 271.85 227.18 281.57 265.86 254.01 261.19 218.6 228.71 210.03",
    style: {
      fill: "#92E3A9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.86,
    y1: 236.65,
    x2: 192.34,
    y2: 247.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "194.4 255.68 198.3 271.55 227.53 281.85 223.91 255.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.63,
    y1: 253.46,
    x2: 222.52,
    y2: 246.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "258.15 260.14 265.94 254.29 262.04 221.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.41,
    y1: 244.83,
    x2: 247.57,
    y2: 228.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "246.46 214.76 228.92 210.03 190.5 236.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.78,
    y1: 237.31,
    x2: 196.63,
    y2: 238.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.65,
    y1: 241.21,
    x2: 222.52,
    y2: 245.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.67,
    y1: 214.21,
    x2: 219.73,
    y2: 232.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.78,
    y1: 234.25,
    x2: 209.15,
    y2: 240.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.27,198.85s6.08,50.15,6.08,52.38-5.57,3.34-5.57,6.12a25,25,0,0,1-1.39,6.68s-1.11,1.12-1.11,2,1.95.56,3.62-.27,2.22-3.9,2.22-3.9a49.53,49.53,0,0,0-.83,5.57l-1.11,1.11s-3.34,3.06-1.12,3.34,12.53-3.62,13.09-6.12-1.4-14.48-1.4-14.48,8.08-56.51,8.08-61.8a7.42,7.42,0,0,0-4.46-7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.79,196.52c-1.17-4.45-2.44-12.53-2.44-12.53l-5.3-1.61-7,8.41,5.53-3.4v66.73c0,3.4-4.25,16.57-4.25,16.57s8.79-1.85,7.37-9.85-3.12-6.72-.57-22.87S266,201,264.79,196.52Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.27,198.85s6.08,50.15,6.08,52.38-5.57,3.34-5.57,6.12a25,25,0,0,1-1.39,6.68s-1.11,1.12-1.11,2,1.95.56,3.62-.27,2.22-3.9,2.22-3.9a49.53,49.53,0,0,0-.83,5.57l-1.11,1.11s-3.34,3.06-1.12,3.34,12.53-3.62,13.09-6.12-1.4-14.48-1.4-14.48,8.08-56.51,8.08-61.8a7.42,7.42,0,0,0-4.46-7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,265.29a5.56,5.56,0,0,1-.28,3.57,14.32,14.32,0,0,1-1.92,2.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,265.29a16.77,16.77,0,0,1-.83,3.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,264.46a17.41,17.41,0,0,1-.83,3.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.88,160.24c-.32-2.88-6.08-8.32-14.08-9.92s-16.65-1.6-19.85,1c-1.2.95-2,3.16-2.52,5.54.57-1.22,1.72-3.69,2.91-4.68,5.89-4.91,7.53-2,8.51,2.29s-.33,16-.33,16-13.42,3.93-11.46-2.95a17.38,17.38,0,0,1-.6-3c0,.51,0,.82,0,.82l-.64,4.16-5.44,1-18.9-.6s9.62,6,15.06,6a15.93,15.93,0,0,0,9.58-3.71l35,2.67S167.2,163.12,166.88,160.24Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,170.22l-21.64-.33s6,5.66,14,5.66,10.66-3.33,10.66-3.33l35,2.67s4.57-8.71,2.24-16.36-23.33-10.22-29.17-8.81c-7.22,1.75-7.7,7.85-7.7,11.18a52.85,52.85,0,0,1-.67,7.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.31,173.71l-14.13.25s-4,5.95-3,7.69a10,10,0,0,0,3,3s-1,7.94.25,10.67,11.16,1.48,11.16,1.48a16.37,16.37,0,0,1-7.2,2.24c-4.71.49-6.19-.5-6.94-3.23s-1-10.57-1-10.57L125,181.65l2.48-6.7,2.73-2.72Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.75,173.22s-3.67,8.66-2,10,2.66,2,2.66,2,1,11.65,2.66,13.65,12.32-1.33,12.32-1.33S165,219.17,165.7,215.17s-2-19-2-20.64-4.66-6-4.66-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,173.55s.66,3,2.66,3.33,3.66-3,3.66-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,174.89s2,6-.34,9.32-3.32,3.33-3.32,3.33c-2,3.33-7.33-4-7.33-4s4-.18,5-2.84-.4-6.55-.4-6.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,174.89s1,4.66,0,7-5,1.66-5,1.66l-2,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,187.14s3.86.83,6.33-3.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.626315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.19,
    y: 209.88,
    width: 8.72,
    height: 13.37,
    transform: "translate(-62.69 81.64) rotate(-20.22)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.92,
    y: 212.12,
    width: 4.17,
    height: 6.2,
    transform: "translate(-62.25 81.37) rotate(-20.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.93,
    y: 207.06,
    width: 1.84,
    height: 4.07,
    transform: "translate(-60.27 80.25) rotate(-20.22)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.43,
    y1: 261.71,
    x2: 193.84,
    y2: 270.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "262.55 157.45 255.2 161.69 251.05 154.44 258.39 150.21 262.55 157.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.07 149.2 248.5 155.88 241.61 143.12 253.18 136.44 260.07 149.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.56,
    cy: 248.43,
    r: 88.96,
    transform: "translate(-85.29 290.94) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,144.2A102.69,102.69,0,1,0,412,246.89,102.69,102.69,0,0,0,309.34,144.2Zm0,191.65a89,89,0,1,1,89-89A89,89,0,0,1,309.34,335.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,169.43a99.72,99.72,0,0,0-34.68-18.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6701700000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.2,148.82a101.56,101.56,0,0,0-11-1.47",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6701700000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.24,301.79a92.91,92.91,0,0,0-2-112.42",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,316.08a91.26,91.26,0,0,0,8.22-8.35",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,331.75a93,93,0,0,0,96-12.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.34,324.5a92.07,92.07,0,0,0,8.61,5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.38,316.94a92.54,92.54,0,0,0,7.32,5.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.66,157.63a92.88,92.88,0,0,0-37.74,157.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,181.23a93,93,0,0,0-84.26-25.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.93,
    y: 279.78,
    width: 26.72,
    height: 7.24,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,246.89a7.45,7.45,0,0,0-6.12-7.33l-.79-48.87h-1.11L308,239.56a7.45,7.45,0,0,0-.23,14.62l-.28,17.34h3.7l-.28-17.34A7.47,7.47,0,0,0,316.8,246.89Zm-7.46,4a4,4,0,1,1,4-4A4,4,0,0,1,309.34,250.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.34,
    cy: 246.89,
    r: 4.11,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.34,
    y1: 162.92,
    x2: 309.34,
    y2: 177.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.34,
    y1: 316.56,
    x2: 309.34,
    y2: 331.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.23,
    y1: 174.21,
    x2: 274.63,
    y2: 187.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.05,
    y1: 307.26,
    x2: 351.45,
    y2: 320.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.4,
    y1: 205.03,
    x2: 249.22,
    y2: 212.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.45,
    y1: 281.85,
    x2: 382.28,
    y2: 289.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.56,
    y1: 247.15,
    x2: 378.75,
    y2: 247.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.92,
    y1: 247.15,
    x2: 225.11,
    y2: 247.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.56,
    y1: 247.15,
    x2: 378.75,
    y2: 247.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.92,
    y1: 247.15,
    x2: 225.11,
    y2: 247.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.28,
    y1: 205.03,
    x2: 369.45,
    y2: 212.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.22,
    y1: 281.85,
    x2: 236.4,
    y2: 289.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.45,
    y1: 174.21,
    x2: 344.05,
    y2: 187.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.63,
    y1: 307.26,
    x2: 267.23,
    y2: 320.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3403500000000004px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.1,
    y: 140.97,
    width: 8.48,
    height: 7.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.66,
    y: 120.93,
    width: 13.36,
    height: 19.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.46,
    y: 107.13,
    width: 19.34,
    height: 13.36,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.67,
    y: 107.13,
    width: 19.34,
    height: 13.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.82,
    y1: 115.44,
    x2: 301.82,
    y2: 107.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.82,
    y1: 120.74,
    x2: 301.82,
    y2: 117.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.28,
    y1: 120.74,
    x2: 304.28,
    y2: 107.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.74,
    y1: 110.76,
    x2: 306.74,
    y2: 107.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.74,
    y1: 120.74,
    x2: 306.74,
    y2: 112.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.81,
    y1: 120.74,
    x2: 310.81,
    y2: 107.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.13,213.14l7.19.5-.24-2.73S168.63,210.41,168.13,213.14Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.32,269.87,163,260.14l-18.75,7.15s-1.7-38.25-.42-41.22,9.35-8.5,9.35-8.5-.48-3.08,2.12-4.25a7.9,7.9,0,0,1,5.53,0l1.85.7c-2.13-1.2-5.57-3.63-10.86-8.57h-.12l1.28,1.23-.56,5-5.62,4.59c-1.27,1.28-6.07,7.38-6.07,7.38l-.28,50.66,7.63-4.91Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,211.7s-11.69,9.47-11.69,12-.84,49.55-.28,50.66S163,260.14,163,260.14l-2.23-20.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.6,
    y1: 234.81,
    x2: 178.26,
    y2: 253.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05,182.38,242.8,178l-46.45-7.81-11.77,12.91s10.2-6.37,13.17-6.37,47.77,12.74,52,13.93Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,192s22.95-21.81,25.73-21.81,48.71,9.18,52.05,9.74,8.91,1.67,8.91,1.67-9.74,12.25-13.08,16.42-5,6.68-5,6.68l-37.58-17.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.04,
    y1: 191.66,
    x2: 217.51,
    y2: 216.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "179.09 229.24 176.86 231.47 166.01 217.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "197.37 192.65 208.38 190.72 199.02 197.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.72,
    y1: 239.82,
    x2: 146.74,
    y2: 237.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.93,206.69a11.44,11.44,0,0,0-.28,7.8c1.39,4.17,6.12,11.41,6.12,11.41l6.12-8.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.84,213.93s3.07-2.78,5.85-2.78h4.73s-.83-10.86-4.73-16.71-9.19-2.78-9.19-2.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,261.81l33.41-15.59,2.78-9.74L209.43,234s2.23-2.23,1.95,0-3.34,3.06-4.45,5.29-1.12,6.68-2.51,8.63-6.4,4.18-6.4,4.18-37.58,31.45-40.36,33.12-8.35-14.2-8.35-14.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-1--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.32,269.87c1.29,2.07,6.56,10.64,6.93,14,.43,3.83,3.83,0,3.83,0l30.6-25.49S159.5,277.49,157,276.64s-3-7.22-3-7.22l9-9.28Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,261.81l33.41-15.59,2.78-9.74L209.43,234s2.23-2.23,1.95,0-3.34,3.06-4.45,5.29-1.12,6.68-2.51,8.63-6.4,4.18-6.4,4.18-37.58,31.45-40.36,33.12-8.35-14.2-8.35-14.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8350869999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.43,234s-5.45,3.25-4.9,4.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.08,
    y1: 235.02,
    x2: 200.95,
    y2: 237.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.417543px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTime);
export default __webpack_public_path__ + "static/media/onTime.46e6185bbe6c8121fc8eeae2cf088d87.svg";
export { ForwardRef as ReactComponent };